import React, {Component} from 'react';
import styles from 'css/screens/result.css';

/**
 * Materialization：ニュース素材化
 */
export default class Materialization extends Component {
  /**
   * render jsx
   * @return {jsx}
   */
  render() {
    return (
      <div className={styles.advice}>
        <h2>御社が強化すべきは<span>ニュース素材化</span>です。</h2>
        <p>
          情報発信だけに目がいっていませんか？<br />
          メディアや顧客にとってわかりやすいニュース素材を<br />
          プレスツールやコンテンツで可視化しましょう。<br />
        </p>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/screens/result/advice/materialization.js